import { EnrolState } from './enrol-state.enum'

export enum MonitoringStatus {
  Pending = 0,
  InProgress = 1,
  Finish = 2,
}

const { Pending, InProgress, Finish } = MonitoringStatus
export const getTranslationKeyMonitoringStatus = (
  modality: MonitoringStatus
) => {
  const modalities = {
    [Pending]: 'pending',
    [InProgress]: 'inProgress',
    [Finish]: 'finish',
  }
  return modalities[modality] || modalities[Pending]
}
export const ENROL_STATUS_MAP = {
  [MonitoringStatus.Finish]: [EnrolState.Approved, EnrolState.Denied],
  [MonitoringStatus.Pending]: [
    EnrolState.Pending,
    EnrolState.Absent,
    EnrolState.ExcusedAbsence,
  ],
}
